import dialogPage from './errorTip.vue';

const errorTip = {
    install: function(Vue) {
        Vue.component('errorTip', dialogPage)
    }
}

export default errorTip;